module.exports = __webpack_public_path__ + "static/media/playground.1f610c33.jpg";